<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../../app.logic";
  import QualityLayout from "../../../layout/QualityLayout.svelte";
  import FormLayout from "../../../layout/FormLayout.svelte";
  import FormField from "../../../components/Form/FormField.svelte";
  import Textarea from "../../../components/Form/Fields/Textarea.svelte";
  import type { IQualityInternalMaintenance } from "../../../entities/quality-internal-maintenance";
  import type { IApiResponse } from "../../../utils/api/api-response";
  import { initDetail, record, save } from "./quality-internal-maintenance.store";
  import DateInputString from "../../../components/Form/Fields/DateInputString.svelte";
  import Input from "../../../components/Form/Fields/Input.svelte";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && $record.description != "" && $record.maintainer != "" && $record.maintenanceDate != "";

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IQualityInternalMaintenance> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/quality-internal-maintenance/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/quality-internal-maintenance`);
  }

  onMount(() => initDetail(oid));
</script>

<QualityLayout>
  {#if $record}
    <div class="columns" style="margin-top:1rem;">
      <div class="column is-12">
        <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
          <div class="columns">
            <div class="column is-4">
              <FormField>
                <DateInputString name="Data Manutenzione" placeholder="" required={true} bind:value={$record.maintenanceDate} />
              </FormField>
            </div>
            <div class="column is-4">
              <FormField>
                <Input name="Manutentore" placeholder="" required={true} bind:value={$record.maintainer} />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column is-12">
              <FormField>
                <Textarea name="Descrizione attività" placeholder="note" required={false} bind:value={$record.description} />
              </FormField>
            </div>
          </div>
        </FormLayout>
      </div>
    </div>
  {/if}
</QualityLayout>
